<template>
  <section class="affiliate-overview" aria-label="Affiliate overview">
    <div class="affiliate-overview__heading">
      <h3>{{ $t('Affiliate overview') }}</h3>
      <span>{{ affiliate.rendered_username }}</span>
    </div>
    <dl class="affiliate-overview__totals">
      <div class="is-due"><dt>{{ $t('Due commissions') }}</dt><dd>{{ affiliate.human_readable_processed_without_advances }}</dd></div>
      <div><dt>{{ $t('Earned commissions') }}</dt><dd>{{ affiliate.human_readable_total_commissions }}</dd></div>
      <div><dt>{{ $t('Total recorded payments') }}</dt><dd>{{ affiliate.human_readable_total_paid }}</dd></div>
    </dl>
    <div class="affiliate-overview__actions">
      <gs-button size="md" variant="primary" @click="$emit('process')">{{ $t('frontend_affiliate_index_process_payment') }}</gs-button>
      <gs-button size="md" variant="outline" @click="$emit('advance')">{{ $t('frontend_affiliate_index_add_commision_advance') }}</gs-button>
      <gs-button size="md" variant="outline" @click="$emit('clawback')">{{ $t('frontend_affiliate_index_add_clawback') }}</gs-button>
      <gs-button size="md" variant="outline" @click="$emit('bonus')">{{ $t('frontend_affiliate_index_tax_ledger_adjustment') }}</gs-button>
      <gs-button v-if="hasNegative" size="md" variant="danger" @click="$emit('negative')">{{ $t('frontend_affiliate_index_fix_negative_balance') }}</gs-button>
    </div>
    <div class="affiliate-overview__details">
      <section>
        <h4>{{ $t('Activity & commissions') }}</h4>
        <dl>
          <div><dt>{{ $t('Impressions / uniques') }}</dt><dd>{{ affiliate.impressions }} / {{ affiliate.uniques }}</dd></div>
          <div><dt>{{ $t('Sales / refunds') }}</dt><dd>{{ affiliate.total_sales }} / {{ affiliate.total_refunds }}</dd></div>
          <div><dt>{{ $t('Pending commissions') }}</dt><dd>{{ affiliate.human_readable_pending_commission }}</dd></div>
          <div><dt>{{ $t('Commissions on hold') }}</dt><dd>{{ affiliate.human_readable_on_hold_commission }}</dd></div>
          <div><dt>{{ $t('Being processed') }}</dt><dd>{{ affiliate.human_readable_in_process_commission }}</dd></div>
        </dl>
      </section>
      <section>
        <h4>{{ $t('Payment details') }}</h4>
        <dl>
          <div><dt>{{ $t('Paid commissions') }}</dt><dd>{{ affiliate.human_readable_alltime_paid_commission }}</dd></div>
          <div><dt>{{ $t('Commission advances') }}</dt><dd>{{ affiliate.human_readable_commission_advance }}</dd></div>
          <div><dt>{{ $t('Clawbacks') }}</dt><dd>{{ affiliate.human_readable_clawbacks }}</dd></div>
          <div><dt>{{ $t('PayPal email') }}</dt><dd class="affiliate-overview__email">{{ affiliate.affiliate_paypal ? affiliate.rendered_affiliate_paypal : $t('frontend_affiliate_index_NA') }}</dd></div>
        </dl>
        <p>{{ $t('frontend_affiliate_index_this_is_for_tax') }}</p>
      </section>
    </div>
  </section>
</template>
<script>
export default {
  props: { affiliate: { type: Object, required: true }, hasNegative: { type: Boolean, default: false } }
};
</script>
<style scoped>
.affiliate-overview { padding: 16px 20px 20px; }
.affiliate-overview__heading { display: flex; align-items: baseline; gap: 12px; margin-bottom: 12px; }
.affiliate-overview__heading h3 { font-size: 15px; font-weight: 600; margin: 0; }
.affiliate-overview__heading span { color: #64748b; font-size: 12px; overflow-wrap: anywhere; }
.affiliate-overview__totals { display: grid; grid-template-columns: repeat(3, 1fr); background: white; border: 1px solid #e3e8ef; border-radius: 10px; overflow: hidden; margin: 0; }
.affiliate-overview__totals > div { padding: 14px 18px; border-right: 1px solid #e3e8ef; }
.affiliate-overview__totals > div:last-child { border-right: 0; }
.affiliate-overview__totals .is-due { background: #fff3f8; }
.affiliate-overview dt { font-size: 12px; color: #64748b; }
.affiliate-overview__totals dd { margin: 5px 0 0; font-size: 24px; line-height: 1.2; font-weight: 600; letter-spacing: -.5px; font-variant-numeric: tabular-nums; }
.affiliate-overview__totals .is-due dd { color: #b54272; }
.affiliate-overview__actions { display: flex; gap: 8px; flex-wrap: wrap; padding: 14px 0; }
.affiliate-overview__details { display: grid; grid-template-columns: 1fr 1fr; gap: 24px; border-top: 1px solid #e3e8ef; padding-top: 14px; }
.affiliate-overview__details h4 { margin: 0 0 8px; color: #334155; font-weight: 600; font-size: 12px; }
.affiliate-overview__details dl { margin: 0; }
.affiliate-overview__details dl > div { display: flex; justify-content: space-between; gap: 16px; align-items: baseline; padding: 7px 0; border-bottom: 1px solid #edf0f5; }
.affiliate-overview__details dd { margin: 0; color: #1e293b; font-size: 13px; font-weight: 500; text-align: right; font-variant-numeric: tabular-nums; }
.affiliate-overview__email { overflow-wrap: anywhere; max-width: 65%; }
.affiliate-overview__details p { margin: 9px 0 0; max-width: 400px; font-size: 11px; line-height: 1.5; color: #64748b; }
@media(max-width: 640px) {
  .affiliate-overview { padding: 12px; }
  .affiliate-overview__totals { grid-template-columns: 1fr; }
  .affiliate-overview__totals > div { padding: 10px 14px; border-right: 0; border-bottom: 1px solid #e3e8ef; display: flex; justify-content: space-between; align-items: center; gap: 12px; }
  .affiliate-overview__totals > div:last-child { border-bottom: 0; }
  .affiliate-overview__totals dd { margin: 0; font-size: 20px; }
  .affiliate-overview__details { grid-template-columns: 1fr; gap: 16px; }
  .affiliate-overview__actions > * { flex: 1 1 calc(50% - 8px); }
}
</style>
